export function cleanOrigin(origin) {
  if (origin.type === "SL") return `'\\n'`;
  if (origin && origin.type === "Col") return `data['${origin.value}']`;
  return origin ? `'${origin.value}'` : "";
}

export function cleanArguments(args) {
  const cleanArgs = [];
  const isArgumentCol = new Array(args.length).fill(false);
  for (let i = 0; i < args.length; i++) {
    if (args[i].type === "Col") isArgumentCol[i] = true;
    cleanArgs.push(cleanOrigin(args[i]));
  }
  return { cleanArgs, isArgumentCol };
}
